module.exports = __webpack_public_path__ + "img/loss-trade.43667987.png";